const scheduleItemsConfig =  require('./scheduleitems-config');

module.exports = scheduleItemsConfig;